import React from 'react';
import { EntityForm } from '../../widgets/Forms';
import { LookupField } from '../../widgets/LookupField';
import { SelectItem } from '../../widgets/SelectItem';
import { CustomTextField } from '../../widgets/CustomTextField';
import { CustomDatePicker } from '../../widgets/CustomDatePicker';
import ProviderSearch from "../provider/ProviderSearch";
import EmployerSearch from "../employer/EmployerSearch";
import LearnerSearch from "../learner/LearnerSearch";
import { Row, Col } from 'react-bootstrap';
import ViewUtils from '../../ViewUtils';
import LearnershipSetupSearch from '../program/LearnershipSetupSearch';
import SkillsProgramSetupSearch from '../program/SkillsProgramSetupSearch';
import TradeSetupSearch from '../program/TradeSetupSearch';
import QCTOLearnershipSetupSearch from '../program/QCTOLearnership/QCTOLearnershipSetupSearch';
import QCTOSkillsProgramSetupSearch from '../program/QCTOSkillsProgramme/QCTOSkillsProgramSetupSearch';
import AETSetupSearch from '../program/AETSetupSearch';
import IIBTCPSetupSearch from '../program/IIBTCP/IIBTCPSetupSearch';

const utils = new ViewUtils();

const ProofOfRegistrationSearchForm = React.forwardRef((props, ref) => {
    const [dependency, setDependency] = React.useState(props.dependency);

    React.useEffect(() => {
        setDependency(props.dependency);
    }, [props.dependency]);

    const onCheckFieldValitationArray = (fields, values) => {
        if (values.FinancialYearID !== null) {
            fields = fields.filter(e => e.id !== "PrintTypeID");
        }
        console.log(fields);
        return fields;
    }

    return (
        <EntityForm ref={ref} viewId="learner" values={props.data}
            entityLookupController={props.entityLookupController} org="saseta"
            entityLookupId={props.id} useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}
            onCheckFieldValitationArray={onCheckFieldValitationArray}
        >
            {form =>
                <form className={form.classes.container} id="SearchForm">
                    <div className="row search-form-container">

                        <div className="col form-col">
                            <SelectItem
                                parentId={0}
                                dataUrl="api/sims/ProofOfRegistration/GetLookupList?listId=LearnerPORLearningProgramme"
                                id="LearningProgrammeID"
                                required={true}
                                label="Programme Type"
                                className="w-100"
                                form={form}
                            />
                        </div>
                        {
                            !utils.isNull(form.values["LearningProgrammeID"]) && form.values["LearningProgrammeID"].Description === "Learnership" ?
                                <div className="col form-col">
                                    <LookupField
                                        id="ProgrammeID"
                                        label="Learnership"
                                        className="w-100"
                                        required={false}
                                        form={form}
                                    >
                                        <LearnershipSetupSearch
                                            showTitle={true}
                                            mode='lookup'
                                            dataUrl='api/sims/ProofOfRegistration/getlearnershipsearch'
                                            onLookupValueChange={(value) => {
                                                form.setLookupSelection("ProgrammeID", value)
                                            }}
                                            autoFetchData={false}
                                            selection={props.selection}
                                        />
                                    </LookupField>
                                </div>
                                :
                                ""
                        }
                        {
                            !utils.isNull(form.values["LearningProgrammeID"]) && form.values["LearningProgrammeID"].Description === "Skills Programme" ?
                                <div className="col form-col">
                                    <LookupField
                                        id="ProgrammeID"
                                        label="Skills Programme"
                                        className="w-100"
                                        required={false}
                                        form={form}
                                    >
                                        <SkillsProgramSetupSearch
                                            showTitle={true}
                                            mode='lookup'
                                            dataUrl='api/sims/ProofOfRegistration/getskillsprogrammesearch'
                                            onLookupValueChange={(value) => {
                                                form.setLookupSelection("ProgrammeID", value)
                                            }}
                                            autoFetchData={false}
                                            selection={props.selection}
                                        />
                                    </LookupField>
                                </div>
                                :
                                ""
                        }
                        {
                            !utils.isNull(form.values["LearningProgrammeID"]) && form.values["LearningProgrammeID"].Description === "Artisan" ?
                                <div className="col form-col">
                                    <LookupField
                                        id="ProgrammeID"
                                        label="Artisan"
                                        className="w-100"
                                        required={false}
                                        form={form}
                                    >
                                        <TradeSetupSearch
                                            showTitle={true}
                                            mode='lookup'
                                            dataUrl='api/sims/ProofOfRegistration/getArtisansearch'
                                            onLookupValueChange={(value) => {
                                                form.setLookupSelection("ProgrammeID", value)
                                            }}
                                            autoFetchData={false}
                                            selection={props.selection}
                                        />
                                    </LookupField>
                                </div>
                                :
                                ""
                        }
                        {
                            !utils.isNull(form.values["LearningProgrammeID"]) && form.values["LearningProgrammeID"].Description === "QCTO Learnership" ?
                                <div className="col form-col">
                                    <LookupField
                                        id="ProgrammeID"
                                        label="QCTO Learnership"
                                        className="w-100"
                                        required={false}
                                        form={form}
                                    >
                                        <QCTOLearnershipSetupSearch
                                            showTitle={true}
                                            mode='lookup'
                                            dataUrl='api/sims/ProofOfRegistration/getqctolearnershipsearch'
                                            onLookupValueChange={(value) => {
                                                form.setLookupSelection("ProgrammeID", value)
                                            }}
                                            autoFetchData={false}
                                            selection={props.selection}
                                        />
                                    </LookupField>
                                </div>
                                :
                                ""
                        }
                        {
                            !utils.isNull(form.values["LearningProgrammeID"]) && form.values["LearningProgrammeID"].Description === "QCTO Artisan" ?
                                <div className="col form-col">
                                    <LookupField
                                        id="ProgrammeID"
                                        label="QCTO Artisan"
                                        className="w-100"
                                        required={false}
                                        form={form}
                                    >
                                        <QCTOLearnershipSetupSearch
                                            showTitle={true}
                                            mode='lookup'
                                            dataUrl='api/sims/ProofOfRegistration/GetQCTOArtisanSearch'
                                            onLookupValueChange={(value) => {
                                                form.setLookupSelection("ProgrammeID", value)
                                            }}
                                            autoFetchData={false}
                                            selection={props.selection}
                                        />
                                    </LookupField>
                                </div>
                                :
                                ""
                        }
                        {
                            !utils.isNull(form.values["LearningProgrammeID"]) && form.values["LearningProgrammeID"].Description === "QCTO Skills Programme" ?
                                <div className="col form-col">
                                    <LookupField
                                        id="ProgrammeID"
                                        label="QCTO Skills Programme"
                                        className="w-100"
                                        required={false}
                                        form={form}
                                    >
                                        <QCTOSkillsProgramSetupSearch
                                            showTitle={true}
                                            mode='lookup'
                                            dataUrl='api/sims/ProofOfRegistration/getqctoskillsprogrammesearch'
                                            onLookupValueChange={(value) => {
                                                form.setLookupSelection("ProgrammeID", value)
                                            }}
                                            autoFetchData={false}
                                            selection={props.selection}
                                        />
                                    </LookupField>
                                </div>
                                :
                                ""
                        }
                        {
                            !utils.isNull(form.values["LearningProgrammeID"]) && form.values["LearningProgrammeID"].Description === "AET" ?
                                <div className="col form-col">
                                    <LookupField
                                        id="ProgrammeID"
                                        label="AET"
                                        className="w-100"
                                        required={false}
                                        form={form}
                                    >
                                        <AETSetupSearch
                                            showTitle={true}
                                            mode='lookup'
                                            dataUrl='api/sims/ProofOfRegistration/GetAETSearch'
                                            onLookupValueChange={(value) => {
                                                form.setLookupSelection("ProgrammeID", value)
                                            }}
                                            autoFetchData={false}
                                            selection={props.selection}
                                        />
                                    </LookupField>
                                </div>
                                :
                                ""
                        }
                        {
                            !utils.isNull(form.values["LearningProgrammeID"]) && form.values["LearningProgrammeID"].Description === "Inhouse Programme" ?
                                <div className="col form-col">
                                    <LookupField
                                        id="ProgrammeID"
                                        label="Inhouse Programme"
                                        className="w-100"
                                        required={false}
                                        form={form}
                                    >
                                        <IIBTCPSetupSearch
                                            showTitle={true}
                                            mode='lookup'
                                            dataUrl='api/sims/ProofOfRegistration/GetIIBTCPSearch'
                                            onLookupValueChange={(value) => {
                                                form.setLookupSelection("ProgrammeID", value)
                                            }}
                                            autoFetchData={false}
                                            selection={props.selection}
                                        />
                                    </LookupField>
                                </div>
                                :
                                ""
                        }
                        <div className="col form-col">
                            <CustomDatePicker
                                id="RegistrationDateFrom"
                                label="Registration Date From"
                                className='{classes.textField} w-100 '
                                form={form}
                            />
                        </div>

                        <div className="col form-col">
                            <CustomDatePicker
                                id="RegistrationDateTo"
                                label="Registration Date To"
                                className='{classes.textField} w-100 '
                                form={form}
                            />
                        </div>

                        <div className="col form-col">
                            <LookupField
                                id="ProviderID"
                                label="Provider"
                                className="w-100"
                                required={false}
                                form={form}
                            >
                                <ProviderSearch
                                    showTitle={true}
                                    mode='lookup'
                                    dataUrl='api/sims/bulklearnercertificate/ProviderSearch'
                                    onLookupValueChange={(value) => {
                                        form.setLookupSelection("ProviderID", value)
                                    }}
                                    autoFetchData={false}
                                    selection={props.selection}
                                />
                            </LookupField>
                        </div>

                        <div className="col form-col">
                            <LookupField
                                id="EmployerID"
                                label="Employer"
                                className="w-100"
                                form={form}
                            >
                                <EmployerSearch
                                    showTitle={true}
                                    mode='lookup'
                                    dataUrl='api/sims/bulklearnercertificate/EmployerSearch'
                                    onLookupValueChange={(value) => {
                                        form.setLookupSelection("EmployerID", value)
                                    }}
                                    autoFetchData={false}
                                    selection={props.selection}
                                />
                            </LookupField>
                        </div>

                        <div className="col form-col">
                            <LookupField
                                id="LearnerID"
                                label="Learner"
                                className="w-100"
                                required={false}
                                form={form}
                            >
                                <LearnerSearch
                                    showTitle={true}
                                    mode='lookup'
                                    dataUrl='api/sims/bulklearnerapproval/LearnerSearch'
                                    onLookupValueChange={(value) => {
                                        form.setLookupSelection("LearnerID", value)
                                    }}
                                    autoFetchData={false}
                                    selection={props.selection}
                                />
                            </LookupField>
                        </div>
                    </div>
                </form>
            }
        </EntityForm >
    );
})

export default ProofOfRegistrationSearchForm;